import { useEffect, useRef } from "react"
import { useAppDispatch } from "app/hooks"
import { resetRecentIngredients } from "features/food/foodSlice"

// Accept string type since IDisplayContent enum is defined in the component file
export const useClearRecentIngredientsOnLeave = (displayContent: string) => {
  const dispatch = useAppDispatch()
  const prevDisplayContent = useRef<string | null>(null)

  useEffect(() => {
    // Clear recent ingredients when:
    // 1. Previous section was RecentIngredients
    // 2. Current section is NOT RecentIngredientDetails
    const shouldClear =
      prevDisplayContent.current === "Recent-ingredients" &&
      displayContent !== "Recent-ingredient-details"

    if (shouldClear) {
      // Clear the list - will auto-reload when user returns
      dispatch(resetRecentIngredients())
    }

    // Update the ref for next comparison
    prevDisplayContent.current = displayContent
  }, [displayContent, dispatch])
}
